import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EditSOCDetails, StartOfCareBO } from '../client-parent.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DateService } from 'src/app/date.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-startofcareedit',
  templateUrl: './startofcareedit.component.html',
  styleUrls: ['./startofcareedit.component.scss'],
})
export class StartofcareeditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() DataFromSOC: EditSOCDetails = new EditSOCDetails();
  @Output() BacktoClientSOC = new EventEmitter<EditSOCDetails>();
  @Output() changevalue = new EventEmitter<EditSOCDetails>();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };
  startOfCare: any = new StartOfCareBO();
  dischargeDateDisable: boolean = false;
  saveSOCErr: string = ""
  companyList: any [];
  DCList: any = [];
  dischargelst: any = [];
  Dcvalue: string = "client"
  enabledischage: boolean = false;
  dischargeStatus: any = [];
  constructor(public CommonAPI: CommonApiService, private datepipe: DatePipe, public global: GlobalComponent, public date: DatePipe, public toastrService: ToastrService, public dateservice: DateService, ) {
  }
  ngOnInit(): void {

    if (this.DataFromSOC.type != "delete") {
      this.getYESNO();
      this.getCompanyList();
      this.getDCList();
      // this.getdischargeLst();
      document.getElementById("modelopensoc").click();
    }
    else {
      document.getElementById("delete").click();
    }
    if (this.DataFromSOC.clientId != '00000000-0000-0000-0000-000000000000') {
      this.startOfCare = this.DataFromSOC.clientSOCData;
      if (this.startOfCare.companyId != null) {
        this.startOfCare.companyId = this.startOfCare.companyId.toString();
      }
      this.startOfCare.startDate = this.datepipe.transform(this.startOfCare.startDate, "MM/dd/yyy");
      this.startOfCare.dischargeDate = this.startOfCare.dischargeDate != null ? this.datepipe.transform(this.startOfCare.dischargeDate, "MM/dd/yyy") : null;
      this.startOfCare.dischargeLid = this.startOfCare.dischargeLid != null ? this.startOfCare.dischargeLid.toString() : null
      if (this.startOfCare.dischargeStatus == "Yes") {
        this.dischargeDateDisable = true;
      }
      this.startOfCare.dischargeCodeDetailId = this.startOfCare.dischargeCodeDetailId != null ? this.startOfCare.dischargeCodeDetailId.toString() : null;
    }
  }
  //======================================ng on changes===================//
  ngOnChanges() {
    this.startOfCare.description;
  }
  //=========================================getcompany list=============================//
  getCompanyList() {
    let url = "api/Company/CommonGetCompanyList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.companyList = data;
      data.forEach(element => {
        element.Value = element.Value;
        element.Key = element.Key.toString();
      })
    })
  }
  //=========================================get dc list=============================//
  getDCList() {
    let url = "api/DischargeCodeDetail/CommonGetDCList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.DCList = data;
      this.DCList.forEach(element => {
        element.Value = element.Value;
        element.Key = element.Key.toString();
      })
    })
  }
  //========================================get Lov drop down==========================//
  getYESNO() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "YESORNO");
    this.CommonAPI.getDropDownList("YESORNO", params, url, "LovDropDown").then((data: any) => {
      this.dischargeStatus = data;
      this.dischargeStatus.forEach(element => {
        element.Value = element.lovName;
        element.Key = element.id.toString();
      })
    })
  }
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
      this.dischargeStatus = data;
      this.dischargeStatus.forEach(element => {
        element.Value = element.lovName;
        element.Key = element.id.toString();
      })
    })
  }
  //=======================================Reset dialog=============================//
  Closedialog() {
    document.getElementById("modelopensoc").click();
    this.BacktoClientSOC.emit(new EditSOCDetails);
  }
  Closedcdialog() {
    document.getElementById("dischargeopen").click();

  }
  closedelete() {
    document.getElementById("delete").click();
    this.BacktoClientSOC.emit(new EditSOCDetails);
  }
  opendischarge() {
    this.enabledischage = true;
    document.getElementById("dischargeopen").click();
  }
  datchange(value) {
    document.getElementById("dischargeopen").click();
    this.getDCList();
    this.startOfCare.description = value.description;
    this.enabledischage = false;
    this.startOfCare.dischargeCodeDetailId = value.code.toString()
  }
  getDischargeValue(checkData) {
    if (checkData == "Yes") {
      this.dischargeDateDisable = true;
    }
    else {
      this.dischargeDateDisable = false;
    }
  }
  //===============================save SOC=============================================================//
  saveSOCRecord(val) {
    let data = JSON.parse(JSON.stringify(val))
    if (data.dischargeDate != null && data.dischargeDate != undefined) {
      if (new Date(data.startDate).getTime() > new Date(data.dischargeDate).getTime()) {
        this.saveSOCErr = "End Date Should greater than Start Date";
        return
      }

    }

    if (this.dischargeStatus.length > 0) {
      if (data.dischargeLid != null && data.dischargeLid != "00000000-0000-0000-0000-000000000000" && data.dischargeLid != undefined) {
        let dischargeStatuslid = this.dischargeStatus?.filter(s => s.Key == data.dischargeLid)[0].Value;
        if (dischargeStatuslid == "Yes") {
          if (this.startOfCare.dischargeDate == null || this.startOfCare.dischargeDate == undefined || this.startOfCare.dischargeDate == '') {
            this.saveSOCErr = "Select Discharge Date";
            return;
          }
        }
      }
      data.dischargeLid = data.dischargeLid != null ? (data.dischargeLid) : null;
      data.companyId = data.companyId != null ? (data.companyId) : null;
      data.dischargeCodeDetailId = data.dischargeCodeDetailId != null ? (data.dischargeCodeDetailId) : null;
      data.clientId = this.global.clientId
      data.startDate = data.startDate != null ? this.global.getDateTimeString(data.startDate) : null;
      data.dischargeDate = (data.dischargeDate != null && data.dischargeDate != undefined && data.dischargeDate != '') ? this.global.getDateTimeString(data.dischargeDate) : null;
      let url = "api/StartOfCare/SaveStartOfCare";
      if (data.id != "00000000-0000-0000-0000-000000000000") {
        this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.toastrService.success(
            'Start of Care updated successfully!',
          );
          this.Closedialog();

        },
          (err: any) => {
            this.saveSOCErr = err;
          });
      }
      else {
        this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(data, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.toastrService.success(
            'Start of Care created successfully!',
          );
          this.Closedialog();
        },
          (err: any) => {

            this.saveSOCErr = err;
          });
      }
    }
  }

  newdates(event, type, name) {

    if (type == "inputchage") {
      if (name == 'dischargeDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.startOfCare.dischargeDate = val1;

        }
      }
      if (name == 'startDate') {
        let val = this.dateservice.inputFeildchange(event);

        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.startOfCare.startDate = val1;

        }
      }
    }
    if (type == "datechagned") {
      if (name == 'dischargeDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.startOfCare.dischargeDate = val1;

        }
      }
      if (name == 'startDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.startOfCare.startDate = val1;

        }
      }

    }
  }
  deleteSOC() {

    let param = new URLSearchParams()
    param.append("Id", this.startOfCare.id.toString())
    let url = "api/StartOfCare/DeleteStartOfCare?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success(
        'Start of Care deleted successfully!',
      );
      this.closedelete();

    },
      (err: any) => {
        this.toastrService.error(
          err,
          'Error');
      })
  }
  getdischargeLst() {
    let url = "api/DischargeCodeDetail/GetDischargeCodeDetailList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.dischargelst = data;
    });
  }
  getDcCode(data) {
    if (data != null && data != undefined && data != "") {
      this.startOfCare.description = this.dischargelst.filter(d => d.id == parseInt(data.toString()))[0].codeDescription
    }

  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}